import { render, staticRenderFns } from "./LogoPage.vue?vue&type=template&id=5c14672a&"
import script from "./LogoPage.vue?vue&type=script&lang=js&"
export * from "./LogoPage.vue?vue&type=script&lang=js&"
import style0 from "./LogoPage.vue?vue&type=style&index=0&id=5c14672a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports